import {getDate} from "../js/tool";

export const getSchFormItems = function (activity) {
    return [
        {
            key: 'startTime',
            label: '开始时间',
            component: 'a-time-picker',
            props: {
                format: 'HH:mm',
                valueFormat: 'HH:mm',
                placeholder: "请选择开始时间"
            },
            style: {
                width: '100%'
            },
            rules: [{ required: true, message: '请选择开始时间', trigger: 'change' }]
        },
        {
            key: 'endTime',
            label: '结束时间',
            component: 'a-time-picker',
            props: {
                format: 'HH:mm',
                valueFormat: 'HH:mm',
                placeholder: "结束时间"
            },
            style: {
                width: '100%'
            },
        },
        {
            key: 'activity_arrange',
            label: '活动安排',
            component: 'a-input',
            props: {
                placeholder: '请输入活动安排',
            },
            rules: [{ required: true, message: '请输入活动安排', trigger: 'blur' }]
        },
        {
            key: 'location',
            label: '地点',
            component: 'item-list',
            props: {
                addTitle: "添加"
            },
            rules: [{ required: true, message: '请添加活动地点', trigger: 'change' }]
        },
        {
            key: 'leader',
            label: '负责人',
            component: 'select-person',
            props: {
                type: 2,
                activity: activity.id,
            },
            rules: [{ required: true, message: '请设置小组组长', trigger: 'change' }]
        },
    ]
}

export const getSchShowTime = function (sch) {
    let time = "";
    if(sch.start_time) {
        time = getDate(sch.start_time).pattern("HH:mm");
        if(sch.end_time) {
            time += ` - ${getDate(sch.end_time).pattern("HH:mm")}`
        }
    }
    return time;
}

export const getActivityTaskId = function (activityId, sort) {
    return activityId && sort ? `${String(activityId).padStart(3, "0")}${String(sort).padStart(4, "0")}` : "--";
}
